import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { usePost } from "../../../hooks/usePost";
import { lightGreyOutline } from "../../../styles";
import {
  FlexibleContainer,
  HorizontalLine,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { mockCoverage } from "./mockData";
import { CompanyCoverage } from "./Coverage";
import { ProviderTab } from "./ProviderTab";
import {
  Coverage,
  Provider,
  PublicMetric,
} from "../../../models/CompanyprofileModels";
import { TabSBTI } from "./TabSBTI";
import { buildCoverageData } from "./util";
import { TabTPI } from "./TabTPI";
import { useToast } from "../../../store/ToastProvider";
import { MESSAGES } from "../../../messages";
import { TabCA100 } from "./TabCA100";

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

export const CompanyNZA = ({
  companyId,
}: {
  companyId: string;
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState<Provider>(Provider.SBTI);
  const { addToast } = useToast();

  const {
    data: metricsData,
    sendData: getMetricsData,
    isLoading: isMetricsDataLoading,
    error: getMetricsDataError,
  } = usePost<PublicMetric[], { compass_cid: string; company_name: null }>();

  useEffect(() => {
    getMetricsData("GET_COMPANY_PUBLIC_METRICS", {
      compass_cid: companyId,
      company_name: null,
    });
  }, []);

  useEffect(() => {
    if (metricsData) {
    }
  }, [metricsData]);

  useEffect(() => {
    if (getMetricsDataError) {
      addToast(MESSAGES.SCREENING_TOOL.ERROR_FETCHING_PUBLIC_METRICS, "error");
    }
  }, [getMetricsDataError]);

  const renderProviderComponent = (isLoading: boolean): JSX.Element => {
    if (isLoading) {
      return (
        <FlexibleContainer
          w="100%"
          fd="column"
          p="10px 5px"
          jc="center"
          ai="flex-start"
          br="6px"
          h="32px"
          isLoading={isLoading}
          ml="12px"
        ></FlexibleContainer>
      );
    }
    switch (activeTab) {
      case Provider.SBTI:
        return <TabSBTI metricsData={metricsData || []} />;
      case Provider.TPI:
        return <TabTPI metricsData={metricsData || []} />;
      case Provider.CA100:
        return <TabCA100 metricsData={metricsData || []} />;
      default:
        return <TabSBTI metricsData={metricsData || []} />;
    }
  };

  const allCoverage = metricsData
    ? buildCoverageData(metricsData)
    : mockCoverage;
  // Net Zero Assessment only shows SBTI, TPI, CA100, NZIF (not NA100)
  const coverage: Record<Provider, Coverage> = {
    [Provider.SBTI]: allCoverage[Provider.SBTI],
    [Provider.TPI]: allCoverage[Provider.TPI],
    [Provider.CA100]: allCoverage[Provider.CA100],
    [Provider.NZIF]: allCoverage[Provider.NZIF],
    [Provider.NA100]: { title: "", isCovered: false },
  };
  const shouldDisplayTabs: boolean = Object.keys(coverage).some(
    (provider) =>
      provider !== Provider.NA100 && coverage[provider as Provider].isCovered
  );

  return (
    <Container>
      <CompanyCoverage coverage={coverage} isLoading={isMetricsDataLoading} />
      {shouldDisplayTabs && (
        <>
          <RowContainer jc="center" ai="center">
            <HorizontalLine
              marginTop={1}
              color={lightGreyOutline}
              thickness={2}
            />
          </RowContainer>

          <ProviderTab
            coverage={coverage}
            handleSetActiveTab={setActiveTab}
            isLoading={isMetricsDataLoading}
          />

          <RowContainer>
            {renderProviderComponent(isMetricsDataLoading)}
          </RowContainer>
        </>
      )}
    </Container>
  );
};
